import { Toast } from '#components/Toast'
import type { BulkUpdateState } from '#hooks/useBulkUpdate'

interface BulkUpdateToolbarProps {
  state: BulkUpdateState
  label?: string
}

const BulkUpdateToolbar = ({
  state,
  label = 'Trigger Update',
}: BulkUpdateToolbarProps) => {
  const {
    selectedCount,
    isTriggering,
    isAllVisibleSelected,
    status,
    dismissStatus,
    triggerUpdates,
    toggleSelectVisible,
  } = state

  return (
    <div className="flex flex-wrap items-center gap-3">
      <button
        type="button"
        className="btn btn-primary btn-sm"
        disabled={selectedCount === 0 || isTriggering}
        onClick={triggerUpdates}
      >
        {isTriggering
          ? 'Triggering...'
          : `${label}${selectedCount === 1 ? '' : 's'}${selectedCount > 0 ? ` (${selectedCount})` : ''}`}
      </button>

      <label className="flex items-center gap-2 text-sm text-base-content/80">
        <input
          type="checkbox"
          className="checkbox checkbox-xs"
          checked={isAllVisibleSelected}
          onChange={() => toggleSelectVisible()}
        />
        <span>Select visible</span>
      </label>

      <span className="text-sm text-base-content/70">
        {selectedCount} selected
      </span>

      {status && (
        <Toast
          type={status.type}
          message={status.message}
          onDismiss={dismissStatus}
        />
      )}
    </div>
  )
}

export { BulkUpdateToolbar }
